import React from 'react'
import {
  SettingsMenuButtonWithIcon,
  SettingsMenuButtonWithIconProps,
} from 'src/editor/shared/components/settings-menu-buttons/settings-menu-button-with-icon'
import { Trash02Icon } from 'src/editor/shared/icons/trash-02-icon'
import { twJoin } from 'tailwind-merge'

export interface FormSubEntitySettingsMenuButtonProps
  extends SettingsMenuButtonWithIconProps {
  onDelete?: (event: React.MouseEvent<SVGSVGElement>) => void
  hideDeleteButton?: boolean
}

export const FormSubEntitySettingsMenuButton = ({
  onDelete,
  hideDeleteButton,
  ...props
}: FormSubEntitySettingsMenuButtonProps) => {
  return (
    <SettingsMenuButtonWithIcon
      className={twJoin(
        'relative mb-2 p-0',
        '[&:has(span>svg:hover)]:hover:bg-none [&:hover>span>svg]:opacity-100',
      )}
      endElement={() =>
        onDelete &&
        !hideDeleteButton && (
          <Trash02Icon
            className="absolute top-[7px] right-[34px] text-iconError opacity-0 transition-opacity duration-150"
            onClick={onDelete}
          />
        )
      }
      {...props}
    />
  )
}
